// Actions
import { SearchActions, SearchActionTypes } from './search.actions';

// Models
import { SearchState } from './search.state';
import { SearchParamsHelper } from '../../../shared/models/b2b/searchParams';

const defaultState: SearchState = {
    loading: undefined,
    orders: [],
    invoices: [],
    products: undefined,
    params: SearchParamsHelper.create(),
    error: '',
    formSubmitAttempt: false,
    isSearchedParts: false,
};

export type Action = SearchActions;

export function SearchReducer(state = defaultState, action: any) {
    switch (action.type) {
        case SearchActionTypes.DO_GET_INFO_PRODUCTS:
            return {
                ...state,
                loading: true,
                error: '',
                products: [],
            };

        case SearchActionTypes.DO_CANCEL_GET_INFO_PRODUCTS:
            return {
                ...state,
                loading: false,
                error: '',
            };

        case SearchActionTypes.DO_GET_INFO_PRODUCTS_OK:
            return {
                ...state,
                loading: false,
                products: { ...action.payload },
                params: { ...action.payload.params },
            };

        case SearchActionTypes.DO_GET_INFO_PRODUCTS_KO:
            return {
                ...state,
                loading: false,
                error: action.payload,
                products: undefined,
            };

        case SearchActionTypes.DO_SET_SEARCH_PARAMS:
            // console.log('guardando: ', action.payload.iccvsuperiores);
            return {
                ...state,
                params: { ...action.payload },
            };

        case SearchActionTypes.DO_SET_FORM_SUBMIT_ATTEMPT:
            return {
                ...state,
                formSubmitAttempt: action.payload,
            };

        case SearchActionTypes.DO_CLEAR_SEARCH:
            return {
                ...state,
                loading: undefined,
                products: undefined,
                params: SearchParamsHelper.create(),
            };

        case SearchActionTypes.DO_CLEAR_PRODUCTS:
            // console.log(state, action);
            return {
                ...state,
                loading: undefined,
                products: undefined,
            };

        case SearchActionTypes.DO_SET_SEARCH_PARTS:
            // console.log(state, action);
            return {
                ...state,
                isSearchedParts: action.payload,
            };

        case SearchActionTypes.DO_SET_LOADING:
            // console.log(state, action);
            return {
                ...state,
                loading: action.payload,
            };

        default:
            return state;
    }
}
